import React from 'react';
import styles from './settingsFormLayout.module.scss';
import { FC, PropsWithChildren } from 'react';

const SettingsFormLayout: FC<PropsWithChildren<{}>> = ({ children }) => {
  return <section className={styles.layout}>{children}</section>;
};

export default SettingsFormLayout;
